import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { styled } from '@components-shared/src/stitches';
import { DisplayToggle } from '@components/shared';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment } from '@graphql/reactQuery';
import { RankCardFragmentDoc } from '@graphql/reactQuery';
import { SPACE } from '@utils/constants';
import { getSingularOrPlural } from '@utils/helpers';

const RANK_MAX = 3;

export const showRank = ({ rank }: { rank: number }) => {
  return rank < RANK_MAX;
};

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment RankCard on ReleaseCollector {
    id
    nftsCount
    gaNftsCount
    vipNftsCount
    firstNftCollectedDate
    user {
      id
      username
    }
  }
`);

export const RankCard = ({
  rankFrag,
  rank,
}: {
  rankFrag: FragmentType<RankCardFragmentDoc>;
  rank: number;
}) => {
  const {
    nftsCount,
    user: { username },
  } = getFragment(RankCardFragmentDoc, rankFrag);
  return (
    <>
      <DisplayToggle media="notTablet">
        <MobileCard>
          <RankNumber>{rank}</RankNumber>
        </MobileCard>
      </DisplayToggle>
      <DisplayToggle media="tablet">
        <Card>
          <Rank>
            <RankNumber>{rank}</RankNumber>
          </Rank>
          <CollectorInfo>
            <Username>{username}</Username>
            <SubText>
              {nftsCount}
              {SPACE}
              {getSingularOrPlural({
                word: 'edition',
                count: nftsCount,
              })}
            </SubText>
          </CollectorInfo>
        </Card>
      </DisplayToggle>
    </>
  );
};

const MobileCard = styled('div', {
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  background: 'rgba(0,0,0, 0.7)',
  backdropFilter: 'blur(6px)',
  borderRadius: 4,
  bottom: 4,
  right: 4,
  padding: 4,
});

const Card = styled('div', {
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  background: 'rgba(0,0,0, 0.7)',
  backdropFilter: 'blur(12px)',
  width: 'calc(100% - 16px)',
  borderRadius: 6,
  padding: 8,
  marginX: 8,
  bottom: 8,
  gap: 8,
});

const Rank = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const RankNumber = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  title: 'XXS',
  color: '$white',
  fontWeight: 700,
  width: 16,

  '@tablet': {
    title: 'XL',
    color: '$white',
    fontWeight: 500,
    width: 32,
  },
});

const CollectorInfo = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

const Username = styled('h2', {
  base: 'M',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: '$white',
});

const SubText = styled('p', {
  base: 'S',
  color: '$white',
  opacity: 0.5,
  fontWeight: 500,
});
